import { useTranslation } from 'react-i18next';

import { BlockingReasonRow } from './BlockingReasonRow';

export function CustomBlockingReason({
  title,
  message,
}: {
  title?: string;
  message: string;
}) {
  const { t } = useTranslation('translation', { keyPrefix: 'checkinBlocker' });

  return (
    <BlockingReasonRow
      title={title || t('blockingReasons.custom.title')}
      message={message || t('blockingReasons.custom.message')}
    />
  );
}
